export const toWrappedText = (value) => {
  return {
    cellValue: value,
    cellDisplay: <p className="wrapped-text">{value}</p>,
  }
}
